import React, { useState } from 'react';
import Button from '../../components/Button';
import Form, { Field, FieldSet, Submit } from '../../components/Form';
import SVGIcon from '../../components/SVGIcon';
import Tooltip from '../../components/Tooltip';
import { UiThemeSetting } from '../../graphql/generated/graphql';
import informationIcon from '../../icons/non-prefilled/16x16/information.svg';
import SettingCard from '../../settings/SettingCard';
import * as styles from './UserThemeSetting.module.scss';

const OPTIONS: Record<UiThemeSetting, string> = {
  AUTO: 'System preference',
  LIGHT: 'Light theme',
  DARK: 'Dark theme',
};

const TOOLTIPS: Partial<Record<UiThemeSetting, string>> = {
  AUTO: 'Automatically switch\nbetween themes based\non your system settings',
};

interface UserThemeSettingProps {
  uiTheme?: UiThemeSetting;
  onUpdateUiTheme: (uiTheme: UiThemeSetting) => Promise<unknown>;
}

const UserThemeSetting = ({
  uiTheme = UiThemeSetting.Auto,
  onUpdateUiTheme,
}: UserThemeSettingProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const title = (
    <div className={styles.labelContainer}>
      <span>Interface theme</span>
    </div>
  );
  return isEditing ? (
    <SettingCard
      description={
        <Form<{ theme?: UiThemeSetting }>
          enableReinitialize
          initialValues={{ theme: uiTheme }}
          onSubmit={async (values) => {
            if (values.theme) {
              await onUpdateUiTheme(values.theme);
              setIsEditing(false);
            }
          }}
        >
          <FieldSet legend={title}>
            {Object.entries(OPTIONS).map(([value, label]) => {
              const tooltip = TOOLTIPS[value as UiThemeSetting];

              return (
                <Field
                  key={value}
                  type="radio"
                  name="theme"
                  value={value}
                  label={
                    <div className={styles.labelContainer}>
                      {label}
                      {tooltip && (
                        <Tooltip placement="right" content={tooltip}>
                          <SVGIcon className={styles.infoIcon}>
                            {informationIcon}
                          </SVGIcon>
                        </Tooltip>
                      )}
                    </div>
                  }
                />
              );
            })}
          </FieldSet>
          <div className={styles.formFooter}>
            <Submit variant="primary">Save</Submit>
          </div>
        </Form>
      }
    />
  ) : (
    <SettingCard
      title={title}
      description={OPTIONS[uiTheme]}
      actions={
        <Button
          variant="secondary"
          onClick={() => {
            setIsEditing(true);
          }}
        >
          Edit
        </Button>
      }
    />
  );
};

export default UserThemeSetting;
